import React from 'react';
import { Alert } from '@/components/ui';
import { Vehicle } from '../../../types/Vehicle';

interface VehicleAttachmentsSectionProps {
  vehicle: Vehicle;
}

const VehicleAttachmentsSection: React.FC<VehicleAttachmentsSectionProps> = ({ vehicle }) => {
  return (
    <div>
      <h2>Vehicle Attachments</h2>
      <Alert variant="info">
        <i className="bi bi-info-circle tw-mr-2"></i>
        This section is not yet developed.
      </Alert>
    </div>
  );
};

export default VehicleAttachmentsSection;
